import React from 'react';
import classNames from "classnames";
import styles from './XColumn.module.scss';
import { XComponent } from '../commons';
import { IColumnProps } from './IColumnProps';
import { IColumnState } from './IColumnState';

export class XColumn extends XComponent<HTMLDivElement, IColumnProps, IColumnState> {
    static defaultProps = {
        ...XComponent.defaultProps
    }
    public constructor(props: IColumnProps) {
        super(props);
    }
    
    public componentDidMount(): void {
        super.componentDidMount();
        const {current} = this.reference;
        let style: string = '';
        if(this.props.width) {
            style += `--width: ${this.props.width};`;
        }
        if(this.props.height) {
            style += `--height: ${this.props.height};`;
        }
        if(style.length > 0)
            current?.setAttribute('style', style);
    }
    public componentWillUnmount(): void {
        super.componentWillUnmount();
    }
    
    public render(): React.ReactNode {
        return (
            <div ref={this.reference} className={classNames(styles.XColumn, this.props.className)}>
                {this.props.children}
            </div>
        );
    }
}
